export default __webpack_public_path__ + "static/media/heart-waiting-red.88aa154b.svg";